<div [ngClass]="isPlp ? 'title-m' : 'title-l'" *ngIf="pricesFormatted$ | async as pricesFormatted">
    <div class="column-gap-8" [class.mb-4]="isPlp" [ngClass]="pricesClasses?.container">
        <!-- Precio terciario -->
        <ng-container *ngIf="terciaryPricesFormatted$ | async as terciaryPricesFormatted">
            <div *ngIf="terciaryPricesFormatted.primaryCurrency" [ngClass]="{ 'mb-4': isPageProduct }">
                <!-- Moneda habitual -->
                <span [classList]="pricesClasses?.terciaryPrice">
                    {{ terciaryPricesFormatted?.primaryCurrency }}
                </span>

                <!-- Moneda alternativa -->
                <ng-container *ngIf="options?.showAlternateCurrencies">
                    <ng-container *ngTemplateOutlet="alternativePrimary; context: { secundaryCurrency: true }"></ng-container>
                </ng-container>
            </div>
        </ng-container>

        <!-- Precio ultimo precio rebajado -->
        <ng-container *ngIf="lastReducedPriceFormatted$ | async as lastReducedPriceFormatted">
            <div *ngIf="lastReducedPriceFormatted.primaryCurrency" [ngClass]="{ 'mb-4': isPageProduct }">
                <!-- Moneda habitual -->
                <span [classList]="pricesClasses?.lastReducedPrice">
                    {{ lastReducedPriceFormatted?.primaryCurrency }}
                </span>

                <!-- Moneda alternativa -->
                <ng-container *ngIf="options?.showAlternateCurrencies">
                    <ng-container *ngTemplateOutlet="alternativePrimary; context: { secundaryCurrency: true }"></ng-container>
                </ng-container>
            </div>
        </ng-container>

        <!-- Precio secundario -->
        <ng-container *ngIf="secondaryPricesFormatted$ | async as secondaryPricesFormatted">
            <div *ngIf="secondaryPricesFormatted.primaryCurrency" [ngClass]="{ 'mb-4': isPageProduct }">
                <!-- Moneda habitual -->
                <span [classList]="pricesClasses?.secondaryPrice" [ngStyle]="pricesStyles?.secondaryPrice">
                    {{ secondaryPricesFormatted?.primaryCurrency }}
                </span>

                <!-- Moneda alternativa -->
                <ng-container *ngIf="options?.showAlternateCurrencies">
                    <ng-container *ngTemplateOutlet="alternativePrimary; context: { secundaryCurrency: true }"></ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <!-- Precio primario -->
    <div
        *ngIf="pricesFormatted?.primaryCurrency"
        class="{{ pricesStyles?.cmsStyles?.backgroundColor ? 'd-price-special' : pricesClasses?.container }}"
        [ngStyle]="
            pricesStyles?.cmsStyles?.backgroundColor || pricesStyles?.cmsStyles?.textColor
                ? {
                      'background-color': pricesStyles?.cmsStyles?.backgroundColor,
                      'color': pricesStyles?.cmsStyles?.textColor
                  }
                : pricesStyles?.primaryPrice
        "
    >
        <div class="text-nowrap" [ngClass]="isPlp ? 'title-m' : 'title-l'">
            <ng-content select="[primaryText]"></ng-content>
            <!-- Moneda habitual -->
            {{ pricesFormatted?.primaryCurrency }}

            <!-- Moneda alternativa -->
            <ng-container *ngIf="options?.showAlternateCurrencies">
                <ng-container *ngTemplateOutlet="alternativePrimary; context: { primaryCurrency: true }"> </ng-container>
            </ng-container>
        </div>
        <ng-content select="[pricesPromotion]"></ng-content>
    </div>

    <!-- Template de precios alternativos -->
    <ng-template #alternativePrimary let-primaryCurrency="primaryCurrency" let-secundaryCurrency="secundaryCurrency">
        <div
            [ngClass]="options?.fromShopToLook ? 'from-shop-to-look' : ''"
            *ngIf="options?.showAlternateCurrencies && pricesFormatted?.secondaryCurrencies.length > 0"
        >
            <ng-container *ngFor="let priceFormatted of pricesFormatted?.secondaryCurrencies; let idx = index">
                <!-- Precio secundario -->
                <ng-container *ngIf="secundaryCurrency && secondaryPricesFormatted$ | async as secondaryPricesFormatted">
                    <span> ({{ secondaryPricesFormatted?.secondaryCurrencies[idx] }}) </span>
                </ng-container>

                <!-- Precio primario -->
                <span *ngIf="primaryCurrency"> ({{ priceFormatted }}) </span>
            </ng-container>
        </div>
    </ng-template>

    <ng-content select="[productPromotionDates]"></ng-content>
</div>

<ng-content select="[productUnitPrice]"></ng-content>
